import { createContractRequest } from './helper';
export const putParticipantRole = createContractRequest({
    route: '/contract/offers/:offerId/participantRoles/:roleId',
    method: 'put',
    source: 'data',
});
